import React, { Component } from "react";
import LeftSideNavigation from "../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import HomeReusableTopBarNavigation from "../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import { Table } from "react-bootstrap";
import { EventsTableHead } from "./eventTables/EventsTableHead";
import { EventsTableBody } from "./eventTables/EventsTableBody";

class SuperAdminRSVP extends Component {
  render() {
    const ittrdata = [
      {
        id: 0,
        onstate: true,
        name: "Zomaland",
        start_date: "25th Mar 20",
        end_date: "28th May 20",
        viewed: 20,
        used: 15,
        live: 20,
        pending_req: "-",
        tickets_booked: "-",
        rsvp: "-",
        primary: false,
        status: false,
      },
      {
        id: 1,
        onstate: false,
        name: "Pune comedy festival",
        start_date: "20th May 20",
        end_date: "28th Jul 20",
        viewed: 20,
        used: 15,
        live: "-",
        pending_req: 10,
        tickets_booked: 50,
        rsvp: 30,
        primary: true,
        status: true,
      },
    ];
    return (
      <React.Fragment>
        <div className="container-fluid superadmin-orderscomponent-main">
          <div className="row">
            <div className="left-side-panel">
              <LeftSideNavigation displayLink={1} />
            </div>
            <div className="super-admin-right-side-panel">
              <HomeReusableTopBarNavigation displayText="All Active Vendors" />
              <div className="super-admin-inside-right-side-panel">
                <div className="seating_dashboard_top_new_header">
                  <div className="row">
                    <div className="col-6">
                      <h2>Mc Donald’s Review</h2>
                      <p>
                        84/36, N Main Rd, Koregaon Park Annexe Mundhwa, Pune,
                        Maharashtra 411001
                      </p>
                    </div>
                  </div>
                  <br />
                  <hr />
                </div>
                <div className="">
                  <h2>Event Management</h2>
                  <div className="col-12 p-0  user-table-reusable-superadmin ">
                    <Table>
                      <thead>
                        <EventsTableHead />
                      </thead>
                      {ittrdata.map((data, index) => {
                        return <EventsTableBody key={index} data={data} />;
                      })}
                    </Table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default SuperAdminRSVP;
